// extracted by mini-css-extract-plugin
export default {"container":"FK-z","topReviewHeading":"GK-z","criticalReview":"HK-z","favorableReview":"IK-z","vsSeparator":"JK-z"};